import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import SSOUser from "../../../social/SSOUser";
import PathogenicityBarchart from "../../../social/PathogenicityBarChart";
import { getReferencedByUsersPerArticle } from "../../../../state/selectors/PubmedUserEntries.selectors";

const ReferencedByUsers = ({ limit, referencedBy, pubmedId }) => {
  const refs = (referencedBy || [])
    .map((x) => x.values)
    .reduce((a, i) => a.concat(i), []);

  const users = (referencedBy || [])
    .map((x) => x.values[0])
    .filter(Boolean)
    .map((x) => ({
      ...x.user,
      coAuthor: x.coAuthor,
      isCurator: x.isSaphetorCuratorLinked ? 1 : 0,
    }))
    .filter(Boolean)
    .sort((a, b) => b.isCurator - a.isCurator || b.coAuthor - a.coAuthor);

  const isSaphetorCuratorLinked = referencedBy
    .map((x) => x.values || [])
    .map((x) => x.map((y) => y.isSaphetorCuratorLinked))
    .map((x) => x.reduce((a, i) => a || i, false))
    .reduce((a, i) => a || i, false);

  const phenotypeSet = refs
    .map((x) => x.phenotypes.concat(x.diseases))
    .reduce((a, i) => a.concat(i), [])
    .map((x) => x.disease_name || x.phenotype_name || x.name)
    .reduce((a, i) => a.add(i), new Set());

  const phenotypes = Array.from(phenotypeSet.values());

  return referencedBy && referencedBy.length ? (
    <>
      <div
        data-tab="classifications"
        className="tw-flex tw-px-2 tw-py-1 tw-items-center tw-gap-x-1 tw-border-b tw-text-2xs tw-opacity-90 hover:tw-opacity-100"
      >
        {isSaphetorCuratorLinked ? (
          <div className="tw-flex-shrink-0 tw-font-bold tw-inline-block tw-bg-sky-500 tw-text-white tw-px-1 tw-rounded">
            VarSome Curator
          </div>
        ) : (
          <span className="tw-flex-shrink-0">Linked by</span>
        )}

        {users.slice(0, limit).map((user, i) => (
          <span
            key={user.screenName}
            className="tw-py-1 tw-rounded-full tw-flex-shrink-0"
            data-tab="none"
          >
            <SSOUser
              defaultName={user.fullName}
              isCoAuthor={user.coAuthor}
              ssoId={user.ssoId}
            />
            {i < Math.min(referencedBy.length, limit) - 1 ? ", " : ""}
          </span>
        ))}

        {referencedBy.length - limit > 0 ? (
          <span
            data-tab="classifications"
            className="w-mt-1 tw-p-1 tw-rounded-full tw-cursor-pointer tw-inline-block tw-flex-shrink-0"
          >
            {`+ ${referencedBy.length - limit} more`}
          </span>
        ) : null}

        <div className="tw-mx-2 tw-h-5 tw-border-r tw-border-blueGray-300" />

        <div className="tw-flex-grow tw-min-w-0 tw-truncate">
          {phenotypes?.length ? (
            <div className="tw-truncate">
              Phenotypes: {phenotypes.join(", ")}
            </div>
          ) : null}
        </div>

        <PathogenicityBarchart pubmedId={pubmedId} />
      </div>
    </>
  ) : null;
};

ReferencedByUsers.propTypes = {
  limit: PropTypes.number.isRequired,
  pubmedId: PropTypes.string.isRequired,
  referencedBy: PropTypes.arrayOf(PropTypes.shape({})),
};

ReferencedByUsers.defaultProps = {
  referencedBy: [],
};

const mapStateToProps = (state, props) => {
  const usersPerArticle = getReferencedByUsersPerArticle(state);
  const { pubmedId } = props;
  const referencedBy = usersPerArticle[`${pubmedId}`] || [];
  return { referencedBy };
};

export default connect(mapStateToProps, {})(React.memo(ReferencedByUsers));
